<template>
  <v-row>
    <v-col
      cols="12"
      md="8"
    >
      <v-card>
        <v-card-title>Formularz DKO Współpraca</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <label class="input-label">Nazwa projektu *</label>
              <v-text-field
                :value="value.name"
                v-bind="props.validatedField"
                :rules="[rules.required]"
                placeholder="Podaj nazwę"
                @input="update('name', $event)"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <label class="input-label">Departament *</label>
              <v-select
                :value="value.departmentId"
                :items="departments"
                item-text="name"
                item-value="id"
                :rules="[rules.required]"
                placeholder="Wybierz departament"
                v-bind="props.select"
                :hide-details="false"
                height="40"
                @input="update('departmentId', $event)"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <label class="input-label">Cel przekazania materiału *</label>
              <v-select
                :value="value.purpose"
                :items="purposes"
                item-text="label"
                item-value="id"
                :rules="[rules.required]"
                placeholder="Wybierz cel"
                v-bind="props.select"
                :hide-details="false"
                height="40"
                @input="update('purpose', $event)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <label class="input-label">Proponowany termin odpowiedzi (minimum 5 dni roboczych)</label>
              <v-menu
                v-model="isDatePickerShown"
                v-bind="props.datePickerMenu"
              >
                <template #activator="{ on, attrs }">
                  <div v-on="on">
                    <v-text-field
                      :value="value.deadline | displayDate"
                      :rules="[rules.required]"
                      v-bind="{ ...attrs, ...props.dateTextField }"
                    />
                  </div>
                </template>
                <v-date-picker
                  :value="value.deadline"
                  :allowed-dates="allowedDates"
                  v-bind="props.datePicker"
                  @input="selectDate"
                />
              </v-menu>
            </v-col>
            <v-col
              v-if="customPurpose"
              cols="12"
              md="6"
            >
              <label class="input-label">Inny cel *</label>
              <v-text-field
                :value="value.customPurpose"
                v-bind="props.validatedField"
                :rules="[rules.required]"
                placeholder="Opisz cel"
                @input="update('customPurpose', $event)"
              />
            </v-col>
          </v-row>

          <label class="input-label">Opis projektu *</label>
          <v-textarea
            :value="value.description"
            outlined
            no-resize
            height="140"
            :rules="[rules.required]"
            @input="update('description', $event)"
          />
        </v-card-text>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <v-card>
        <v-card-title class="text-body-1">
          Opcjonalne zadania dodatkowe dla DKO:
        </v-card-title>
        <v-card-text>
          <v-checkbox
            v-for="option in optionalTasks"
            :key="option.key"
            :input-value="value[option.key]"
            :label="option.label"
            hide-details
            class="mt-0 mb-2"
            @change="update(option.key, $event)"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      props,
      rules,
      isDatePickerShown: false,
      optionalTasks: [
        { key: 'usageAssessment', label: 'Ocena sposobu wykorzystania znaku NBP' },
        { key: 'kiwNumberAssignment', label: 'Nadanie numeru KIW' },
        { key: 'externalEntityApproval', label: 'Zgoda na przekazanie znaku NBP podmiotowi zewnętrznemu' },
        {
          key: 'printCoordination',
          label: 'Materiał będzie drukowany (poligrafia NBP lub na zewnątrz na zlecenie DKO)',
        },
      ],
    };
  },
  computed: {
    ...mapState('filters', ['filtersOptions']),
    departments() {
      return this.filtersOptions.departments || [];
    },
    purposes() {
      return this.filtersOptions.dkoCooperationRequestPurposes || [];
    },
    customPurpose() {
      const selected = this.purposes.find((purpose) => purpose.id === this.value.purpose);
      return Boolean(selected?.custom);
    },
  },
  methods: {
    update(key, next) {
      const form = { ...this.value, [key]: next };
      if (key === 'purpose' && !this.purposes.find((purpose) => purpose.id === next)?.custom) {
        form.customPurpose = '';
      }
      this.$emit('input', form);
    },
    selectDate(date) {
      this.update('deadline', date);
      this.isDatePickerShown = false;
    },
    allowedDates(date) {
      const selected = new Date(date);
      selected.setHours(0, 0, 0, 0);
      const day = selected.getDay();
      if (day === 0 || day === 6) return false;

      const minimum = new Date();
      minimum.setHours(0, 0, 0, 0);
      minimum.setDate(minimum.getDate() + 7);
      return selected >= minimum;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--checkbox .v-label {
  white-space: normal;
  line-height: 1.3;
}
</style>
